import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-rate/src/index.js
// module id = 844
// module chunks = 0